var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "play_svg__ionicon",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133 440a35.37 35.37 0 01-17.5-4.67c-12-6.8-19.46-20-19.46-34.33V111c0-14.37 7.46-27.53 19.46-34.33a35.13 35.13 0 0135.77.45l247.85 148.36a36 36 0 010 61l-247.89 148.4A35.5 35.5 0 01133 440z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGNsYXNzPSJpb25pY29uIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPHBhdGggZD0iTTEzMyA0NDBhMzUuMzcgMzUuMzcgMCAwMS0xNy41LTQuNjdjLTEyLTYuOC0xOS40Ni0yMC0xOS40Ni0zNC4zM1YxMTFjMC0xNC4zNyA3LjQ2LTI3LjUzIDE5LjQ2LTM0LjMzYTM1LjEzIDM1LjEzIDAgMDEzNS43Ny40NWwyNDcuODUgMTQ4LjM2YTM2IDM2IDAgMDEwIDYxbC0yNDcuODkgMTQ4LjRBMzUuNSAzNS41IDAgMDExMzMgNDQweiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPg==";
export { SvgPlay as ReactComponent };